// React polyfill
import 'react-app-polyfill/ie11';

// ES 6 shims for IE11.
import 'es6-shim';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import 'object-assign';
import 'promise';

import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'daemonite-material/css/material.min.css';
import './stylesheets/index.css';
// JS libs for bootstrap
import 'popper.js';
import 'bootstrap';
import App from './App';

// Minimal Promise.allSettled polyfill
if (!Promise.allSettled) {
  Promise.allSettled = function(promises) {
    return Promise.all(promises.map(p =>
      Promise.resolve(p)
        .then(value => ({ status: 'fulfilled', value }))
        .catch(reason => ({ status: 'rejected', reason }))
    ));
  };
}

// We do not use service works for now
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();
